import React, { useState, useEffect } from "react";
import { ChevronDown, Book, Award, Gavel, GraduationCap, Building, Search, Globe, BookOpen } from "lucide-react";
import SearchComponent from "../../../Includes/Header/Essentials/Search/Search";

const courseOptions = [
    { id: "All", name: "All", icon: <Globe className="w-5 h-5 text-blue-400" /> },
    { id: "upsc", name: "UPSC", icon: <Award className="w-5 h-5 text-red-400" /> },
    { id: "ias", name: "IAS", icon: <Building className="w-5 h-5 text-green-400" /> },
    { id: "pcs", name: "PCS", icon: <Book className="w-5 h-5 text-yellow-400" /> },
    { id: "publications", name: "Publications", icon: <BookOpen className="w-5 h-5 text-purple-400" /> },
    { id: "judiciary", name: "Judiciary", icon: <Gavel className="w-5 h-5 text-gray-500" /> },
    { id: "teaching", name: "Teaching", icon: <GraduationCap className="w-5 h-5 text-orange-400" /> },
];

const slides = [
    {
        image: "/images/Dashboard/all.png",
        url: "/all",
    },
    {
        image: "/images/Dashboard/upsc.png",
        url: "/upsc",
    },
    {
        image: "/images/Dashboard/pcs.png",
        url: "/state-pcs",
    },
    {
        image: "/images/Dashboard/teaching.png",
        url: "/teaching-exams",
    },
    {
        image: "/images/Dashboard/judiciary.png",
        url: "/judiciary",
    },
    {
        image: "/images/Dashboard/cuet.png",
        url: "/cuet",
    },
    {
        image: "/images/Dashboard/publication.png",
        url: "/publications",
    },
];

const handleClick = (path) => {
    console.log('path',path);
    window.open(path, '_blank');
};

const TopSection = ({ SelectedVertical, onVerticalSelect }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedCourse, setSelectedCourse] = useState(courseOptions[0]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const goToSlide = (index) => {
        if (isTransitioning || index === currentSlide) return;
        setIsTransitioning(true);
        setCurrentSlide(index);
        setTimeout(() => setIsTransitioning(false), 500);
    };

    useEffect(() => {
        const autoSlide = setInterval(() => {
            if (!isTransitioning) {
                setCurrentSlide((prev) => (prev + 1) % slides.length);
            }
        }, 3000);

        return () => clearInterval(autoSlide);
    }, [isTransitioning]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(".dropdown-container")) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="bg-gradient-to-br from-blue-50 to-white min-h-[100%] lg:min-h-[100%] transition-all duration-300">
            <div className="h-full w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-6 py-8 md:py-12">
                <div className="h-full flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-16">
                    <div className="w-full lg:w-1/2 space-y-6">
                        <h1 className="text-4xl sm:text-5xl  text-[#4267b2] leading-tight">Welcome to</h1>
                        <div className="text-[#0f172a] text-4xl sm:text-5xl font-bold">Drishti Learning App</div>
                        <p className="text-base sm:text-lg text-gray-600">Empower Your Learning with Expert Guidance from Top Faculties</p>

                        {/* Search Section */}
                        {/* <div className="flex items-center gap-2 mt-6 bg-white border border-gray-100 rounded px-4 py-3 shadow-sm">
                            // Dropdown
                            <div className="dropdown-container relative">
                                <button onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="flex items-center gap-2 text-gray-700 focus:outline-none">
                                    {selectedCourse.icon}
                                    <span className="font-medium">{selectedCourse.name}</span>
                                    <ChevronDown className="w-4 h-4" />
                                </button>
                                {isDropdownOpen && (
                                    <div className="absolute z-10 mt-2 bg-white border rounded-lg shadow-lg">
                                        {courseOptions.map((option) => (
                                            <button
                                                key={option.id}
                                                className="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 text-gray-700 w-full text-left"
                                                onClick={() => {
                                                    setSelectedCourse(option);
                                                    setIsDropdownOpen(false);
                                                }}
                                            >
                                                {option.icon}
                                                <span>{option.name}</span>
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                            // Vertical Line
                            <div className="h-10 border-l border-gray-400"></div>
                            // Search Input
                            <div className="relative flex-1">
                                <input
                                    type="text"
                                    placeholder="Search"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="w-full bg-gray-0 pl-4 pr-4 py-2 text-gray-0 rounded focus:outline-none focus:ring-2 focus:ring-[#4f6cbb]"
                                />
                            </div>

                            // Search Button
                            <button className="flex items-center gap-2 bg-[#4f6cbb] text-white px-5 py-2 rounded hover:bg-[#3c5aa6] transition">
                                <Search className="w-5 h-5" />
                                <span>Search</span>
                            </button>
                        </div> */}





                        <div className="search-container">
                            <SearchComponent SelectedVertical={SelectedVertical} onVerticalSelect={onVerticalSelect} isForNewDashboard={true} showSearchInput={true} />
                        </div>






                    </div>

                    {/* Banners Section */}
                    <div className="w-full lg:w-2/6 relative">
                        
                        <div className="aspect-[4.5/3] w-full max-w-[450px] mx-auto relative ">
                            <div className="absolute inset-0 rounded-2xl overflow-hidden shadow-sm">
                                {slides.map((slide, index) => (
                                    <a
                                        href={slides[currentSlide].url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleClick(slides[currentSlide].url);
                                        }}
                                        className="absolute inset-0 block"
                                    >
                                        <img
                                            src={slides[currentSlide].image}
                                            alt={`Slide ${currentSlide + 1}`}
                                            className="w-full h-full object-fill rounded-2xl"
                                            loading="eager"
                                        />
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Dot Navigation */}
                        <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 flex items-center gap-3">
                            {slides.map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => goToSlide(index)}
                                    className={`w-3 h-3 rounded-full transition-all duration-300 ${currentSlide === index ? "bg-[#4267B2] w-8" : "bg-gray-300 hover:bg-gray-400"}`}
                                    aria-label={`Go to slide ${index + 1}`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopSection;
